import SendIcon from './SendIcon'

export default SendIcon
